import React, { useEffect } from "react";
import { Row, Col, Form } from "antd";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import Selects from "../../../../biblio/Selects/Selects";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import {
  getAllBankAccounts,
  getBeneficiaryDetails,
  addBankAccount,
} from "../../../../apis/actions/recipient.actions";
import { showNotitfication } from "../../../../components/utils/utils";
import Inputs from "../../../../biblio/Inputs/Inputs";
import {
  toGetAllBanks,
} from "../../../../apis/actions/sponsor.actions";
interface Props {
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const BankAccountRequest = ({ setIsModalVisible}: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();

  const beneficiaries = useSelector(
    (state: RootState) => state?.recipient?.beneficiaryDetails
  );
  const bankAccounts = useSelector(
    (state: RootState) => state?.recipient.bankAccounts
  );
  const banks = useSelector((state: RootState) => state?.sponsor.banks);

  useEffect(() => {
    dispatch(getAllBankAccounts());
    dispatch(getBeneficiaryDetails());
    dispatch(toGetAllBanks());
  }, [dispatch]);


  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const bankAccountData = {
        person_id: values.person_id.value,
        bank_id: values.bank_id.value,
        acc_number: values.acc_number,
        acc_holder_name: values.acc_holder_name,
      };

      dispatch(addBankAccount(bankAccountData)).then((result: any) => {
        const response = result?.payload?.data?.result;
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setIsModalVisible(false);
          dispatch(getAllBankAccounts());
        } else {
          showNotitfication(response?.message, "error");
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Row justify={"center"} style={{ paddingBottom: "2rem" }}>
        <p className="takaful--confirm-logout">إضافة حساب بنكي </p>
      </Row>

      <Form form={form} layout="vertical">
        <Row gutter={[16, 16]} dir="rtl">
          {/* المستفيد: person_id */}
          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="person_id"
              label="المستفيد"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects
                options={
                  Array.isArray(beneficiaries?.person_ids)
                    ? beneficiaries.person_ids
                        .filter(
                          (person: any) =>
                            person.beneficiary_state !== "dead" && 
                            !bankAccounts.some(
                              (account: any) => account.partner_id === person.id
                            )
                        )
                        .map((person: any) => ({
                          id: person.id,
                          name: person.name,
                        }))
                    : []
                }
                selectPlaceholder="اختر المستفيد"
              />
            </Form.Item>
          </Col>

          {/* البنك: bank_id */}
          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="bank_id"
              label="البنك"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects
                options={banks.map((bank: any) => ({
                  id: bank.id,
                  name: bank.name,
                }))}
                selectPlaceholder="اختر البنك"
              />
            </Form.Item>
          </Col>

          {/* رقم الحساب: acc_number */}
          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
                name="acc_number"
                label="رقم الحساب"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="tel" />
              </Form.Item>
          </Col>

          {/* صاحب الحساب: acc_holder_name */}
          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="acc_holder_name"
              label="صاحب الحساب"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs placeholder="صاحب الحساب" />
            </Form.Item>
          </Col>

          <Col span={24} style={{ textAlign: "end" }}>
            <PrimaryButton title="إرسال" onClick={handleSubmit} />
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default BankAccountRequest;
